var map = {
	"./Golden-Snitch-Rigged-00.jpg": 187,
	"./Golden-Snitch-Rigged-01.jpg": 188,
	"./Golden-Snitch-Rigged-02.jpg": 189,
	"./Golden-Snitch-Rigged-03.jpg": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;